import { FaArrowRight } from "react-icons/fa"
import Mockup1 from '../../../assets/images/s3_mockup_1.png'
import Mockup2 from '../../../assets/images/s3_mockup_2.png'
import Mockup3 from '../../../assets/images/s3_mockup_3.png'
import Tool from '../../../assets/images/s3_tools.png'
import Daun from '../../../assets/images/s3_daun.png'


const Section3 = () => {
    return (
        <div className="w-full h-screen flex flex-col md:flex-row">
            <div className="w-full md:w-[40%] h-full flex flex-col items-start justify-center px-5 md:px-0 md:pl-10 gap-3">
                <h1 className="text-3xl md:text-5xl font-bold text-custom-green">Introduction</h1>
                <p className="text-justify pb-5 md:pr-10">
                    <span className="font-bold text-custom-green">Kebun Jitu</span> sedang mengembangkan alat analisis tanah instan dan portabel yang membantu petani hortikultura lokal membudidayakan tanaman mereka berdasarkan data serta meningkatkan produktivitas mereka.
                </p>
                <button type='button' className=' text-white flex items-center justify-center gap-2 font-semibold'>
                    <span className='bg-custom-orange rounded-full px-5 py-2 capitalize'>Pelajari lebih lanjut</span>
                    <div className='rounded-full bg-custom-orange h-10 aspect-square flex items-center justify-center'>
                        <FaArrowRight />
                    </div>
                </button>
            </div>
            <div className="w-full md:w-[60%] flex justify-end relative gap-3 md:pt-16 pr-5 md:pr-10">
                <img src={Daun} alt="Kebun Jitu" className="max-w-[250px] object-contain absolute -left-5 md:-left-10 bottom-0 hidden md:flex" loading='lazy' />
                <img src={Mockup1} alt="Kebun Jitu" className="max-w-[100px] md:max-w-[150px] object-contain"  loading='lazy'/>
                <div className="">
                    <img src={Mockup2} alt="Kebun Jitu" className="max-w-[100px] md:max-w-[150px] object-contain"  loading='lazy'/>
                    <img src={Tool} alt="Kebun Jitu" className="max-w-[100px] md:max-w-[150px] object-contain" loading='lazy' />
                </div>
                <img src={Mockup3} alt="Kebun Jitu" className="max-w-[100px] md:max-w-[150px] object-contain" loading='lazy' />
            </div>
        </div>
    )
}

export default Section3